var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"w-100 h-100 border-1s",attrs:{"src":"https://wholesale.wookah.pl/api/public/api/tutorial","type":"application/pdf"}},[_vm._v(" Oops! an error has occurred. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }